import React from 'react';
import ClearIcon from "@mui/icons-material/Clear";
import userFilterIcon from "../../../../../styles/svg/userFilterIcon.svg";
import { CustomButton } from '../../../../../components/Button/Button';

const UserFilter = ({ selectedUsers, clearFilters }) => {
  if (!selectedUsers) return null;

  return (
    <div onClick={() => clearFilters('clear')} className="d-flex align-items-center">
      <img
        src={userFilterIcon}
        alt="user filter"
        className="cursor-pointer"
      />
      <CustomButton
        size="small"
        endIcon={<ClearIcon />}
        className="capitalize ml-0 board-header-user-filter-btn reset-btn"
      >
        {`Users (${selectedUsers?.length})`}
      </CustomButton>
    </div>
  );
};

export default UserFilter; 